import { DateTime } from "luxon";
import { DreamSearchViewerResult } from "@portal/app/_common/types/dreamSearch";

export const isTestimonial = (item: DreamSearchViewerResult | Testimonial): item is Testimonial =>
  (item as Testimonial).text !== undefined;

export interface Testimonial {
  text: string;
  name: string;
  city: string;
  state: string;
}

export const getRotatingTestimonial = (testimonialIndexOffset: number) => {
  const minute = DateTime.local().minute;
  const currentIndex = Number(
    (minute + testimonialIndexOffset).toString().padStart(2, "0").substring(1)
  );
  return studentTestimonials[currentIndex];
};

export const getTestimonialItemIndexes = (numItems: number, pageSize: number): number[] => {
  // don't show card if ~1 row of results
  // otherwise put card in middle of results
  if (numItems < 5) {
    return [];
  }
  return (
    /**
     * Sets a testimonial index for the middle of every page.
     * So for a pageSize of 25 with numItems of 25, we'd have [12].
     * For a pageSize of 10 with numItems of 30, we'd have [5, 15, 25].
     */
    Array(Math.floor(numItems / (pageSize / 2)))
      .fill(null)
      .reduce(
        (acc, _) => {
          const nextIndex = acc[acc.length - 1] + pageSize;
          // Can only have as many testimonials as there are in studentTestimonials
          return nextIndex < numItems && acc.length < studentTestimonials.length
            ? [...acc, nextIndex]
            : acc;
        },
        [Math.floor(pageSize / 2)]
      )
  );
};

export const studentTestimonials: Testimonial[] = [
  {
    text: "Simple process… I've finally accomplished something I wanted to do over so many years.",
    name: "Latriya T",
    city: "San Antonio",
    state: "TX",
  },
  {
    text: "Dreambound platform was very easy to understand and navigate!",
    name: "Kayla H",
    city: "Gainesville",
    state: "FL",
  },
  {
    text: "It's easy and makes the process way much faster.",
    name: "Laura G",
    city: "Houston",
    state: "TX",
  },
  {
    text: "Such an easy platform to use! I can't wait to get started on my nursing career.",
    name: "Katelyn M",
    city: "Dallas",
    state: "TX",
  },
  {
    text: "You guys have changed my life.",
    name: "Keyarika D",
    city: "Beaumont",
    state: "TX",
  },
  {
    text: "I was searching a way to get back in school... with one click I was able to find more information.",
    name: "Christina T",
    city: "Fort Myers",
    state: "FL",
  },
  {
    text: "Love the layout of the website and the information is so clear and answers a lot of my questions!",
    name: "Kaitlyn B",
    city: "Jacksonville",
    state: "FL",
  },
  {
    text: "The Dreambound platform is simple and easy to use. I am excited about making this new step.",
    name: "Takarra W",
    city: "Miami",
    state: "FL",
  },
  {
    text: "I was excited to see an organized resource that led to me finding a great educational program.",
    name: "Rexie M",
    city: "Athens",
    state: "GA",
  },
  {
    text: "The system is user friendly and the staff are on top of it, to get you started.",
    name: "Delina P",
    city: "San Francisco",
    state: "CA",
  },
];
